module.exports = __webpack_public_path__ + "img/vehicle-options-black.f3ac0ff9.png";